export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[700px] mx-auto bg-background-50 rounded-2xl border border-background-200/60 p-8 md:p-10 text-center">
          <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-secondary-100 flex items-center justify-center">
            <i className="ri-mail-send-line text-secondary-600 text-2xl"></i>
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-3">合作与投稿</h2>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-[500px] mx-auto">
            欢迎影视内容创作者、版权方与我们联系合作。番茄视频致力于为优质内容提供高清播放平台，共同打造更好的观影体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-foreground-600">
            <div className="flex items-center gap-2">
              <i className="ri-mail-line text-primary-500"></i>
              <span>contact@fanqie.video</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-background-300"></div>
            <div className="flex items-center gap-2">
              <i className="ri-customer-service-line text-accent-500"></i>
              <span>在线客服：每日 9:00 - 22:00</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}